<template>
  <div v-if="loading" class="loading">
    <div class="loading-item">
      <!-- <pulse-loader /> -->
      <span class="spinner" style="font-size:3em"><i class="fa fa-spinner fa-spin"></i></span> 
      <span class="title">Olá, é a sua primeira vez aqui? <br> Por favor aguarde, estamos carregando as informações de receitas para você.</span>
    </div>
  </div>

  <div v-else class="row receitas">
    <public-header :title="'Receita Resumida'">
      <ano-base />
      <div class="row">
        <div class="col-sm-6">
          <p>
            Aqui você encontra um resumo das receitas recebidas pela Prefeitura
            Municipal de Santos.
          </p>
          <p>
            A Prefeitura Municipal de Santos, no ano de
            <span class="destaque-header">{{ anoAtual }}</span>
            até o mês de
            <span class="destaque-header">{{
              retornaMesComparativo
            }}</span
            >, arrecadou um total de
            <span class="destaque-header">
              {{ `${formatarMoeda(receitaAtual)} (${(receitaAtual / orcamentoAtual * 100).toFixed(2).replace('.', ',')}%)` }}
            </span>
            de um orçamento estimado para este ano de
            <span class="destaque-header">{{ formatarMoeda(orcamentoAtual) }}</span
            >.
          </p>
          <p>
            Dentre os maiores valores arrecadados, em relação ao total,
            <span class="destaque-header">{{
              `${filtrarPorCodigo('Impostos, Taxas e Contribuições de Melhoria').atual.vl_total} (${(filtrarPorCodigo('Impostos, Taxas e Contribuições de Melhoria').atual.vl_total_f / (receitaAtual || 1) * 100).toFixed(2).replace('.', ',')}%)`
            }}</span>
            são provenientes de impostos, taxas e contribuições de melhoria e
            <span class="destaque-header">{{
              `${filtrarPorCodigo('Transferência Correntes').atual.vl_total}  (${(filtrarPorCodigo('Transferência Correntes').atual.vl_total_f / (receitaAtual || 1) * 100).toFixed(2).replace('.', ',')}%)`
            }}</span>
            são provenientes de transferências correntes.
          </p>
        </div>
        <div class="col-sm-6">
          <p>
            <bar-chart
              ref="receita_mensal"
              :chart-data="graficoHeader"
              :gradiente="false"
              :coloredLine="true"
              :options="{
                responsive: true,
                maintainAspectRatio: false,
                title: {
                  display: true,
                  text: 'Acompanhamento de receitas',
                  fontColor: '#C1D1C1'
                },
                legend: {
                  display: true,
                  labels: {
                    fontColor: '#C1D1C1',
                  },
                },
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        beginAtZero: true,
                        suggestedMax: 50,
                        fontColor: '#C1D1C1',
                        callback: function (value, index, values) {
                          return value.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                          })
                        },
                      },
                    },
                  ],
                  xAxes: [
                    {
                      maxBarThickness: 50,
                      ticks: {
                        fontColor: '#C1D1C1',
                      },
                    },
                  ],
                },
                tooltips: {
                  callbacks: {
                    label: function (tooltip, dataset) {
                      var xLabel = dataset.datasets[tooltip.datasetIndex].label
                      var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })
                      return xLabel + ': ' + yLabel
                    },
                  },
                },
              }"
            ></bar-chart>
          </p>
        </div>
      </div>
    </public-header>
    <div class="container">
      <div class="row">
        <ol class="breadcrumb">
          <li><router-link :to="'/'">Início</router-link></li>
          <li><router-link :to="'/receitas_despesas'">Receitas e Despesas</router-link></li>
          <li class="">Receitas</li>
        </ol>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h2>Arrecadações em Destaque</h2>
        </div>
      </div>

      <div class="row">
        <card :data="listaCards" />
      </div>

      <div class="row">
        <div class="col-xs-12 text-center">
          <h2>Para mais detalhes</h2>

          <div class="button-group">
            <router-link
              tag="button"
              :to="{ name: 'receitas_detalhes', params: { id: 1 } }"
              class="btn btn-primary"
              >Receitas correntes</router-link
            >
            <router-link
              tag="button"
              :to="{ name: 'receitas_detalhes', params: { id: 2 } }"
              class="btn btn-primary"
              >Receitas de capital</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BarChart, PublicHeader, AnoBase } from '@/components/common/'
import colors from '@/utils/colors.js'
import { mesesAbr, formatarMoeda } from '@/utils/strings.js'
import Card from '../Card'
import { mapState } from 'vuex'

export default {
  components: { PublicHeader, BarChart, Card, AnoBase },
  data() {
    return {
      cores: [],
      graficos_base: { labels: [], datasets: [{ label: '', data: [] }] },
      items: {
        iptu: {
          title: 'IPTU',
          nome: 'Imposto sobre a Propriedade Predial e Territorial Urbana',
        },
        issqn: {
          title: 'ISSQN',
          nome: 'Imposto sobre Serviços de Qualquer Natureza'
        },
        itbi: {
          title: 'ITBI',
          nome: 'Transmissão "Inter Vivos" de Bens Imóveis e de Direitos Reais sobre Imóveis'
        },
        ir_fonte: {
          title: 'Imposto de Renda Retido na Fonte',
          nome: 'Imposto sobre a Renda - Retido na Fonte'
        },
        taxas: {
          title: 'Taxas',
          nome: 'Taxas'
        },
        fundeb: {
          title: 'FUNDEB',
          nome: 'Transferências de Recursos do Fundo de Manutenção e Desenvolvimento da Educação Básica e de Valorização dos Profissionais da Educação - FUNDEB'
        },
        ipva: {
          title: 'IPVA',
          nome: 'Cota-Parte do IPVA'
        },
        transf_uniao: {
          title: 'Transferências da União',
          nome: 'Transferências da União e de suas Entidades'
        },
        transf_estado: {
          title: 'Transferências do Estado',
          nome: 'Transferências dos Estados e do Distrito Federal e de suas Entidades'
        }
      },
    }
  },
  created() {
    this.cores = [...colors.coresHexa]
  },
  methods: {
    filtrarPorCodigo(codigo) {
      const { receitas_proprias } =
        this.$store.state.receitas_despesas

      const filterByID = (obj) => {
        if ('ds_plano_conta' in obj && obj.ds_plano_conta.includes(codigo)) {
          return true
        } else {
          return false
        }
      }

      const atual = { ...receitas_proprias.filter(filterByID) }

      return { atual: atual[0] }
    },
    infoCards(codigo) {
      const receita = this.filtrarPorCodigo(codigo)
      const percentual = ((receita.atual.vl_total_f / (receita.atual.vl_atualizado_f || 1)) * 100).toFixed(0)

      return [
        { label: 'Previsão Anual', value: receita.atual.vl_atualizado },
        { label: 'Arrecadado', value: receita.atual.vl_total },
        {
          label: 'Percentual',
          value: `Arrecadado aproximadamente ${percentual}% da previsão`,
        },
      ]
    },
    formatarMoeda,
  },
  computed: {
    ...mapState({
      anoAtual: state => state.receitas_despesas.ano_base
    }),
    retornaMesComparativo () {
      const data = new Date()
      if (this.anoAtual !== data.getFullYear()) {
        return new Date(this.anoAtual, 11, 31).toLocaleString('default', { month: 'long' })
      }

      return data.toLocaleString('default', { month: 'long' })
    },
    loading () {
      return this.receitas.length === 0
    },
    receitas () {
      return this.$store.state.receitas_despesas.receitas_proprias
    },
    listaCards() {
      const keys = Object.keys(this.items)
      const items = []

      for (let index = 0; index < keys.length; index++) {
        const element = this.items[keys[index]]

        items.push({
          title: element.title,
          data: this.infoCards(element.nome),
          link: `receitas/detalhes/${this.filtrarPorCodigo(element.nome).atual.cd_plano_conta_rel}/`,
          tooltip: this.filtrarPorCodigo(element.nome).atual.ds_plano_conta
        })
      }

      return items
    },
    graficoHeader() {
      const dadosCorrente = this.filtrarPorCodigo('Receitas Correntes')
      const dadosCapital = this.filtrarPorCodigo('Receitas de Capital')
      let labelFinal = []
      let data = []
      let acum = 0

      for (let index = 0; index < mesesAbr.length; index++) {
        const element = mesesAbr[index].toLowerCase()

        if (dadosCorrente.atual[`vl_${element}_f`] === '0' 
         && dadosCapital.atual[`vl_${element}_f`] === '0') {
          break;
        }

        labelFinal.push(mesesAbr[index])
        acum += Number(dadosCorrente.atual[`vl_${element}_f`]) + Number(dadosCapital.atual[`vl_${element}_f`])
        data.push(acum)
      }

      const previsaoAtual = Array(labelFinal.length).fill(this.orcamentoAtual)

      return {
        ...this.graficos_base,
        labels: labelFinal,
        datasets: [
          {
            type: 'line',
            label: `Previsão Anual - ${this.anoAtual}`,
            backgroundColor: this.cores[0],
            borderColor: this.cores[0],
            fill: false,
            data: previsaoAtual,
          },
          {
            label: `Receita Acumulada - ${this.anoAtual}`,
            backgroundColor: this.cores[1],
            data: data,
          },
        ],
      }
    },
    receitaAtual() {
      const { loading, formatarMoeda, filtrarPorCodigo } = this

      if (loading) {
        return formatarMoeda(0)
      }

      const receitaCorrente = filtrarPorCodigo('Receitas Correntes').atual.vl_total_f
      const receitaCapital = filtrarPorCodigo('Receitas de Capital').atual.vl_total_f

      return Number(receitaCorrente) + Number(receitaCapital)
    },
    orcamentoAtual() {
      const { loading, formatarMoeda, filtrarPorCodigo } = this

      if (loading) {
        return formatarMoeda(0)
      }

      const receitaCorrente = filtrarPorCodigo('Receitas Correntes').atual.vl_atualizado_f
      const receitaCapital = filtrarPorCodigo('Receitas de Capital').atual.vl_atualizado_f

      return Number(receitaCorrente) + Number(receitaCapital)
    }
  }
}
</script>

<style scoped>
  div.loading {
    min-height: 65vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  div.loading-item {
    display: block;
    text-align: center;
  }

  div.loading span.title {
    display: block;
    font-size: 1.7em;
  }

  .receitas {
    margin-bottom: 30px;
  }

.button-group {
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}

.button-group button {
  height: 80px;
  width: 400px;
}
</style>


// WEBPACK FOOTER //
// src/views/public/receitas_despesas/receitas/index.vue